<template>
  <div class="contacts" v-loading="loading_loding">
    <div class="menu">
      <div class="tt">
        <el-button icon="el-icon-my-add" @click="add_contact_add()" type="primary">添加联系人</el-button>
      </div>
      <div class="screen">
        <div @click="userType=2;get_contacts()" :class="userType==2?'on':''">全部联系人（{{contact_num[1]+contact_num[0]}}）</div>
<!--        <div @click="userType=1;get_contacts()" :class="userType==1?'on':''">企业联系人（{{contact_num[1]}}）</div>-->
<!--        <div @click="userType=0;get_contacts()" :class="userType=='0'?'on':''">个人联系人（{{contact_num[0]}}）</div>-->
      </div>
    </div>
    <card-box class="list" title="联系人列表">
      <div class="tt">我的联系人</div>
      <el-table
        :data="contacts"
        header-row-class-name="contacts-header"
        style="width: 100%;"
        row-class-name="contact"
        class="contact_tb el-table-_row"
        height="calc(100% - 120px)"
        :header-cell-style="{height: '40px'}"
        stripe
      >
        <template slot="empty">
          <img src="@/assets/img/nullDate.png" style="width: 285px;height: 145px; margin-left: -67px;"/>
          <p style="color:rgba(49,202,132,1);font-size: 18px;margin: 0">暂无数据</p>
        </template>
        <el-table-column prop="userName" align="center" width="76" class="el-table-_row">
          <template slot-scope="scope" >
            <el-image class="contacts_imgUrl" :src="scope.row.imgUrl">
              <div
                slot="error"
                class="contacts_imgUrl_df"
              >{{scope.row.userName?scope.row.userName.slice(-2):scope.row.remarkName.slice(-2)}}</div>
            </el-image>
          </template>
        </el-table-column>
        <el-table-column prop="userName" align="left" label="账户名" :show-overflow-tooltip="true"  >
          <template slot-scope="scope">{{scope.row.userName||scope.row.userAccount}}</template>
        </el-table-column>
        <el-table-column prop="remarkName" align="center" label="备注名称" :show-overflow-tooltip="true"  ></el-table-column>
        <el-table-column prop="userAccount" align="center" label="账号" :show-overflow-tooltip="true"  ></el-table-column>
        <el-table-column label="账号类型" align="center">
          <template slot-scope="scope">{{ scope.row.userType==0?'个人账号':'企业账号'}}</template>
        </el-table-column>
        <el-table-column align="center" prop="createDate" label="添加时间"></el-table-column>
        <el-table-column align="center" label="操作">
          <template slot-scope="scope">
            <el-button
              icon="el-icon-my-setting"
              @click="Modify(scope.row) "
              type="text"
            >编辑</el-button>
            <el-button
              @click="present_contact=scope.row;del_contact_dialog=true"
              icon="el-icon-my-delete"
              type="text"
            >删除</el-button>
          </template>
        </el-table-column>
      </el-table>
      <el-pagination
       id="guang_b"
      :hide-on-single-page="hide_pagination"
        background
        :page-sizes="[5, 10, 20, 50]"
        :page-size="pageSize"
         @size-change="handleSizeChange"
        @current-change="handleCurrentChange"
        layout="prev, pager, next,sizes,jumper"
        :total="pages_total"
      ></el-pagination>
    </card-box>
    <el-dialog :close-on-click-modal="false"  v-dialogDrag title="增加联系人" :visible.sync="add_contact_dialog" width="617" center :before-close="del_dialog">
      <el-form ref="new_contact_form" :model="new_contact" label-width="80px">
        <el-form-item label="用户类型">
          <el-select id="guang_b_s" v-model="new_contact.userType" placeholder="请选择">
            <el-option label="企业用户" :value="1"></el-option>
            <el-option label="个人用户" :value="0"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="账号">
          <el-input v-model="new_contact.addValue"  placeholder="请输入账号"></el-input>
        </el-form-item>
        <el-form-item label="备注名称">
          <el-input v-model="new_contact.remarkName"  placeholder="请输入备注"></el-input>
        </el-form-item>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button :loading="loding_s" @click="add_contact(false)" type="primary">保存并继续添加</el-button>
        <el-button :loading="loding_s" @click="add_contact(true)" type="primary">保存</el-button>
        <el-button @click="del_dialog" plain>取消</el-button>
      </span>
    </el-dialog>
    <el-dialog :close-on-click-modal="false" v-dialogDrag title="编辑联系人" :visible.sync="edit_contact_dialog" width="617" center>
      <el-form ref="present_contact" :model="present_contact"  label-width="80px">
        <el-form-item label="账号">{{present_contact.userAccount}}</el-form-item>
        <el-form-item label="用户名">{{present_contact.userName || present_contact.userAccount}}</el-form-item>
        <el-form-item label="备注名称" prop="remarkName">
          <el-input v-model="present_contact.remarkName"></el-input>
        </el-form-item>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button :loading="loding_s" @click="edit_contact()" type="primary">保存修改</el-button>
        <el-button @click="edit_contact_dialog=false" plain>取消</el-button>
      </span>
    </el-dialog>
    <el-dialog :close-on-click-modal="false"  v-dialogDrag title="删除联系人" :visible.sync="del_contact_dialog" width="617" center>
      <div class="del_contact">
        <div class="hint">您确定删除此联系人？</div>
        <div class="msg">
          <div class="name">{{present_contact.remarkName}}</div>
          <div class="account">{{present_contact.userAccount}}</div>
        </div>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button :loading="loding_s" @click="del_contact" type="primary">确认删除</el-button>
        <el-button @click="del_contact_dialog=false" plain>取消删除</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
export default {
  data() {
    return {
      contacts: [],
      contact_num: {
        0: 0,
        1: 0
      },
      pageSize: 10,
      pageNum: 1,
      pages_total: 0,
      contacts_imgUrl: [],
      hide_pagination:false,
      loading_loding:false,
      add_contact_dialog: false,
      new_contact: {
        addValue: "",
        remarkName: "",
        userType: 0
      },
      del_contact_dialog: false,
      edit_contact_dialog: false,
      loding_s: false,
      present_contact: {
        remarkName:''
      },
      userType:2
    }
  },
  created() {
    this.get_contacts();
    this.get_all_contacts();
  },
  methods: {
    add_contact_add(){
      this.add_contact_dialog = true
      setTimeout(() =>{
        var add_input = document.getElementById("guang_b_s")
        add_input.type='button'
        add_input.style.textAlign='left'
      },1000);

    },
    Modify(i){
      this.present_contact=JSON.parse(JSON.stringify(i))
      this.edit_contact_dialog=true
    },
    del_dialog(){
      this.new_contact={
        addValue: "",
        remarkName: "",
        userType: 1
      }
      this.add_contact_dialog = false
    },
    // 获取联系人列表
    get_all_contacts() {
      this.$SIF.httpPost({
        url: this.$SIF._serve.usermanage + "/contacts/query/list",
        succFun: res => {
          var dt = res.data;
          this.contact_num = {
            0: 0,
            1: 0
          }
          for (var k = 0; k < dt.length; k++) {
            this.contact_num[dt[k].userType]++;
          }
        }
      });
    },
    handleCurrentChange(val) {
      this.pageNum = val;
      this.get_contacts();
    },
     handleSizeChange(val) {
         this.pageSize = val;
      this.get_contacts();
      },
    get_contacts() {
      this.loading_loding =true
      var entity=this.userType!=2?{
              userType: this.userType
            }:{}
      this.$SIF.httpPost({
        url: this.$SIF._serve.usermanage + "/contacts/queryPage",
        data: {
          	entity: entity,
          pageBean: {
            pageSize: this.pageSize,
            pageNum: this.pageNum
          }
        },
        succFun: res => {
          var dt = res.data.list;
          this.contacts = dt;
          this.pages_total = res.data.total;
          this.loading_loding =false
          // var add_input = document.getElementById("guang_b").getElementsByTagName('input')[0]
          // add_input.type='button'
        },
        failFun:res=>{
          this.loading_loding =false
        }
      });
    },
    // 添加联系人
    add_contact(close) {
      this.loding_s = true
      if(this.new_contact.userType == 0){
        let reg =/^[1][3,4,5,6,7,8,9][0-9]{9}$/;
        if (!reg.test(this.new_contact.addValue)) {
          this.$message({
            message: "请输入正确手机号",
            type: 'warning'
          });
          this.loding_s = false
          return false;
        }
      }else {
        let reg =/^[a-zA-Z0-9_-]+@[a-zA-Z0-9_-]+(\.[a-zA-Z0-9_-]+)+$/;
        let num = /^([0-9A-HJ-NPQRTUWXY]{2}\d{6}[0-9A-HJ-NPQRTUWXY]{10}|[1-9]\d{14})$/;
        if (!reg.test(this.new_contact.addValue) && !num.test(this.new_contact.addValue)) {
          this.$message({
            message: "请输入正确企业邮箱号/社会信用代码",
            type: 'warning'
          });
          this.loding_s = false
          return false;
        }
      }
      var that = this;
      this.$SIF.httpPost({
        url: this.$SIF._serve.usermanage + "/contacts/add",
        data: that.new_contact,
        succFun: res => {

          this.$message({
            message: "添加成功",
            type: "success"
          });
          that.loding_s = false
          if (close) {
            that.loding_s = false
            that.add_contact_dialog = false;
          }
          this.get_contacts();
          this.get_all_contacts();
          that.new_contact = {
            addValue: "",
            remarkName: "",
            userType: 1
          };
        },
        failFun: res => {
          that.loding_s = false
          that.$message({
            message: res.msg,
            type: 'warning'
          });
        }
      });
    },
    del_contact() {
      this.loding_s = true
      this.$SIF.httpPost({
        url: this.$SIF._serve.usermanage + "/contacts/delete",
        data: {
          id: this.present_contact.id
        },
        succFun: res => {
          this.loding_s = false
          this.$message({
            message: "删除成功",
            type: "success"
          });
          this.del_contact_dialog = false;
          this.get_contacts();
          this.get_all_contacts();
        },
        failFun: res => {
          this.loding_s = false
          this.$message({
            message: res.msg,
            type: 'warning'
          });
        }
      });
    },
    // 修改联系人
    edit_contact() {
      this.loding_s = true
      if(!this.present_contact.remarkName){
        this.$message({
          message: "备注名不能为空",
          type: 'warning'
        });
        this.loding_s = false
        return
      }
      this.$SIF.httpPost({
        url: this.$SIF._serve.usermanage + "/contacts/update",
        data: this.present_contact,
        succFun: res => {
          this.loding_s = false
          this.$message({
            message: "保存成功",
            type: "success"
          });
          this.edit_contact_dialog = false;
          this.get_contacts();
        },
        failFun: res => {
          this.loding_s = false
          this.$message({
            message: res.msg,
            type: 'warning'
          });
        }
      });
    }
  }
};
</script>
<style scoped type="text/css">
.contacts {
  display: flex;
  justify-content: space-between;
  height: 100%;
}

.contacts_imgUrl {
  width: 36px;
  height: 36px;
  border-radius: 18px;
  overflow: hidden;
  display: inline-block;
  vertical-align: middle;
  margin-right: 11px;
  margin-left: 30px;
}
.contacts .menu {
  width: 225px;
  background: rgba(255, 255, 255, 1);
  box-shadow: 0px -2px 7px 0px rgba(164, 161, 161, 0.23);
  border-radius: 5px;
  flex-shrink: 0;
  margin-right: 22px;
}
.contacts .menu .screen > div {
  padding-left: 28px;
  font-size: 14px;
  text-align: left;
  line-height: 40px;
  cursor: pointer;
}
.el-table-_row /deep/ td:first-of-type .cell{
  text-overflow:clip;

}
.contacts .menu .screen > div.on {
  color: #31b471;
  background: rgba(49, 202, 132, 0.14);
}
.contacts .menu .screen > div:hover {
  color: #31b471;
  background: rgba(49, 202, 132, 0.14);
}
.contacts .list {
  width: calc(100% - 248px);
  height: 100%;
  position: relative;
}
.list .tt {
  font-size: 18px;
  color: #333333;
  padding-left: 52px;
  padding-top: 10px;
  line-height: 57px;
  font-weight: 600;
  border-bottom: 1px #eaedf1 solid;
}
.del_contact {
  text-align: center;
}
.del_contact .hint {
  font-size: 14px;
  color: #5f5f5f;
  margin-bottom: 16px;
}
.del_contact .msg {
  background: rgba(49, 202, 132, 0.18);
  border-radius: 3px;
  display: inline-block;
  color: #1c965e;
  font-size: 18px;
  padding: 10px 30px;
  min-width: 182px;
}
.del_contact .msg .account {
  font-size: 14px;
  line-height: 28px;
}
</style>
<style>

.contact {
  color: #4a4a4a;
  font-size: 12px;
}

.contacts-header {
  color: #278e60;
  font-size: 12px;
  padding: 0 60px;
}
.contact td {
  border: none !important;
}
.contacts-header th {
  border: none !important;
}
.el-table .contacts-header th > .cell,
.contact td .cell {
  padding: 0;
}
.contacts_userName {
  font-size: 14px;
}
.contacts_imgUrl_df {
  font-size: 14px;
  line-height: 36px;
  text-align: center;
  color: #fff;
  background: #5E97F6;
}
.contacts .menu .tt {
  text-align: center;
  padding: 15px 0;
  width: 182px;
  margin: 0 auto;
  border-bottom: 1px #eaedf1 solid;
  margin-bottom: 22px;
}
.contacts .menu .tt .el-button {
  width: 150px;
  height: 35px;
  line-height: 35px;
  background: rgba(49, 202, 132, 1);
  border-radius: 3px;
  font-size: 14px;
  padding: 0;
  margin: 0 auto;
}
.el-table::before {
  height: 0;
}
/* .contacts .el-dialog__header {
  padding: 0;
  background-color: #31ca84;
  line-height: 35px;
}
.contacts .el-dialog__title {
  line-height: 35px;
  color: #ffffff;
  font-size: 16px;
}
.contacts .el-dialog {
  border-radius: 4px;
  overflow: hidden;
  width: 617px;
} */
.contacts .el-dialog form {
  width: 60%;
  margin: 0 auto;
}
.contacts .el-dialog form .el-select {
  width: 100%;
}
#guang_b_s{
  overflow: hidden;
}
/*.el-select-dropdown__list{*/

/*  overflow: hidden;*/
/*  width: 99.9%;*/
/*  height: 90px;*/
/*}*/
/*.el-select-dropdown__item{*/
/*  overflow: hidden;*/
/*}*/
/*.el-scrollbar__wrap{*/
/*  overflow: hidden;*/
/*}*/
/* .contacts .el-dialog__headerbtn {
  font-size: 19px;
  top: 8px;
  right: 13px;
}
.contacts .el-dialog__headerbtn .el-dialog__close {
  color: #fff;
}
.contacts .dialog-footer .el-button {
  padding: 0 10px;
  line-height: 33px;
  height: 33px;
  min-width: 117px;
  border-radius: 8px;
  font-size: 16px;
  font-weight: bold;
  margin: 0 13px;
}
.contacts .dialog-footer .el-button--default {
  border-color: #19bc73;
  color: #19bc73;
  font-weight: normal;
} */
</style>